

// "use client";

// import React, { useState, useCallback } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   IconButton,
//   Typography,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Paper,
//   SelectChangeEvent,
//   Button,
//   Popover,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";
// import { Cancel, Add as AddIcon, EmojiEmotions } from "@mui/icons-material";
// import data from "@emoji-mart/data";
// import Picker from "@emoji-mart/react";
// import DragDrop from "../../../components/drag-drop/DragDrop";
// import { Util } from "../../../../core/util/util";

// // -----------------------------------------------------------------------------
// // Interfaz ContentBlock (ajusta según tu proyecto)
// export interface ContentBlock {
//   id: string;
//   type: string;
//   title?: string;
//   content?: string;
//   listItems?: string[];
//   listImage?: string;
//   image?: string;
//   videoUrl?: string;
//   quote?: string;
//   testimonials?: {
//     testimonialName: string;
//     testimonialDescription: string;
//     testimonialSource?: string;
//   }[];
//   imageTextItems?: { image?: string; text: string }[];
//   background?: string; // "sin_fondo" o "claro"
//   imageResizable?: boolean;
// }

// // -----------------------------------------------------------------------------
// // Estado para el EmojiPicker
// interface EmojiPickerState {
//   anchorEl: HTMLElement | null;
//   field: string | null;
//   listItemIndex?: number;
// }

// // -----------------------------------------------------------------------------
// // Props del componente ContentBlockForm
// interface ContentBlockFormProps {
//   index: number;
//   block: ContentBlock;
//   onChange: (block: ContentBlock, index: number) => void;
//   onRemove: (index: number) => void;
//   onReorder: (oldIndex: number, newIndex: number) => void;
//   maxPosition: number;
//   disabled?: boolean;
//   isSpartan?: boolean;
// }

// // Función de utilidad para procesar archivos
// const getFileUrl = (files: any[]): string => {
//   if (!files || files.length === 0) return "";
//   const file = files[0];
//   return file?.blob ? URL.createObjectURL(file.blob) : "";
// };

// const ContentBlockForm: React.FC<ContentBlockFormProps> = ({
//   index,
//   block,
//   onChange,
//   onRemove,
//   onReorder,
//   maxPosition,
//   disabled = false,
//   isSpartan = false,
// }) => {
//   const [openReorderModal, setOpenReorderModal] = useState(false);
//   const [desiredPosition, setDesiredPosition] = useState(index + 1);
//   const [emojiPickerState, setEmojiPickerState] = useState<EmojiPickerState | null>(null);

//   const handleTypeChange = useCallback((e: SelectChangeEvent<string>) => {
//     const selectedType = e.target.value;
//     let newBlock: Omit<ContentBlock, "id"> = { type: selectedType, background: "sin_fondo" };
//     if (selectedType.startsWith("text")) {
//       newBlock = { type: selectedType, title: "", content: "", background: "sin_fondo" };
//     } else if (selectedType === "image") {
//       newBlock = { type: selectedType, image: "", background: "sin_fondo" };
//     } else if (selectedType === "video") {
//       newBlock = { type: selectedType, videoUrl: "", background: "sin_fondo" };
//     } else if (selectedType === "quote") {
//       newBlock = { type: selectedType, quote: "", background: "sin_fondo" };
//     } else if (selectedType === "list") {
//       newBlock = {
//         type: selectedType,
//         listItems: [""],
//         title: "",
//         listImage: "",
//         background: "sin_fondo",
//       };
//     } else if (selectedType === "testimonial") {
//       newBlock = {
//         type: selectedType,
//         testimonials: [{ testimonialName: "", testimonialDescription: "" }],
//         background: "sin_fondo",
//       };
//     } else if (selectedType === "image_text_block") {
//       newBlock = { type: selectedType, imageTextItems: [{ text: "" }], background: "sin_fondo" };
//     }
//     onChange({ ...newBlock, id: Util.getUniqueId(4) }, index);
//   }, [index, onChange]);

//   const handleInputChange = useCallback(
//     (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
//       onChange({ ...block, [e.target.name]: e.target.value }, index),
//     [block, index, onChange]
//   );

//   const handleSelectChange = useCallback(
//     (e: SelectChangeEvent<string>) =>
//       onChange({ ...block, [e.target.name]: e.target.value }, index),
//     [block, index, onChange]
//   );

//   const handleFiles = useCallback(
//     (files: any[]) => {
//       const url = files[0]?.blob ? URL.createObjectURL(files[0].blob) : "";
//       onChange({ ...block, image: url }, index);
//     },
//     [block, index, onChange]
//   );

//   const handleListImageFiles = useCallback(
//     (files: any[], items: { image?: string; text: string }[], i: number) => {
//       const newItems = [...items];
//       newItems[i] = {
//         ...newItems[i],
//         image: files[0]?.blob ? URL.createObjectURL(files[0].blob) : "",
//       };
//       onChange({ ...block, imageTextItems: newItems }, index);
//     },
//     [block, index, onChange]
//   );

//   const handleListItemChange = useCallback(
//     (val: string, i: number) => {
//       if (!block.listItems) return;
//       const newList = [...block.listItems];
//       newList[i] = val;
//       onChange({ ...block, listItems: newList }, index);
//     },
//     [block, index, onChange]
//   );

//   const handleAddListItem = useCallback(() => {
//     if (!block.listItems || block.listItems.length >= 10) return;
//     onChange({ ...block, listItems: [...block.listItems, ""] }, index);
//   }, [block, index, onChange]);

//   const handleRemoveListItem = useCallback(
//     (i: number) => {
//       if (!block.listItems) return;
//       onChange({ ...block, listItems: block.listItems.filter((_, idx) => idx !== i) }, index);
//     },
//     [block, index, onChange]
//   );

//   const handleTestimonialChange = useCallback(
//     (
//       e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
//       ti: number,
//       field: "testimonialName" | "testimonialDescription" | "testimonialSource"
//     ) => {
//       if (!block.testimonials) return;
//       const newT = [...block.testimonials];
//       newT[ti] = { ...newT[ti], [field]: e.target.value };
//       onChange({ ...block, testimonials: newT }, index);
//     },
//     [block, index, onChange]
//   );

//   const handleAddTestimonial = useCallback(() => {
//     if (!block.testimonials || block.testimonials.length >= 8) return;
//     onChange(
//       { ...block, testimonials: [...block.testimonials!, { testimonialName: "", testimonialDescription: "" }] },
//       index
//     );
//   }, [block, index, onChange]);

//   const handleRemoveTestimonial = useCallback(
//     (ti: number) => {
//       if (!block.testimonials) return;
//       onChange({ ...block, testimonials: block.testimonials.filter((_, idx) => idx !== ti) }, index);
//     },
//     [block, index, onChange]
//   );

//   const handleEmojiButtonClick = useCallback(
//     (field: string, e: React.MouseEvent<HTMLElement>, listIdx?: number) => {
//       if (disabled) return;
//       setEmojiPickerState({ anchorEl: e.currentTarget, field, listItemIndex: listIdx });
//     },
//     [disabled]
//   );

//   const handleEmojiSelect = useCallback(
//     (emoji: any) => {
//       if (!emojiPickerState?.field) return;
//       const ch = emoji.native;
//       const { field, listItemIndex } = emojiPickerState;
//       if (field === "listItem" && listItemIndex != null && block.listItems) {
//         handleListItemChange(block.listItems[listItemIndex] + ch, listItemIndex);
//       } else if (
//         field === "testimonialDescription" &&
//         listItemIndex != null &&
//         block.testimonials
//       ) {
//         handleTestimonialChange(
//           { target: { value: (block.testimonials[listItemIndex].testimonialDescription || "") + ch } } as any,
//           listItemIndex,
//           "testimonialDescription"
//         );
//       } else {
//         onChange({ ...block, [field]: ((block as any)[field] || "") + ch }, index);
//       }
//       setEmojiPickerState(null);
//     },
//     [block, emojiPickerState, handleListItemChange, handleTestimonialChange, index, onChange]
//   );

//   const handleEmojiClose = useCallback(() => setEmojiPickerState(null), []);

//   const contentLength = block.content?.length || 0;

//   return (
//     <Paper elevation={3} sx={{ p: 3, mb: 3, backgroundColor: disabled ? "grey.100" : "background.paper", position: "relative" }}>
//       <Grid container justifyContent="space-between" alignItems="center">
//         <Typography variant="h6">Bloque #{index + 1}</Typography>
//         <Box>
//           <Button
//             variant="outlined"
//             onClick={() => { setDesiredPosition(index + 1); setOpenReorderModal(true); }}
//             disabled={disabled}
//             sx={{ mr: 2 }}
//           >
//             MOVER
//           </Button>
//           <IconButton onClick={() => onRemove(index)} disabled={disabled} color="error">
//             <Cancel />
//           </IconButton>
//         </Box>
//       </Grid>

//       {/* Reorder Modal */}
//       <Dialog open={openReorderModal} onClose={() => setOpenReorderModal(false)}>
//         <DialogTitle>Mover Bloque</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Elige posición entre 1 y {maxPosition}.</DialogContentText>
//           <TextField
//             autoFocus margin="dense" label="Posición" type="number" fullWidth variant="standard"
//             value={desiredPosition}
//             onChange={(e) => setDesiredPosition(Number(e.target.value))}
//             onBlur={() => {
//               let v = Number(desiredPosition);
//               if (isNaN(v) || v < 1) v = 1;
//               else if (v > maxPosition) v = maxPosition;
//               setDesiredPosition(v);
//             }}
//             inputProps={{ min: 1, max: maxPosition }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenReorderModal(false)}>Cancelar</Button>
//           <Button variant="contained" onClick={() => { onReorder(index, desiredPosition - 1); setOpenReorderModal(false); }}>
//             Aceptar
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Box mt={2}>
//         <Grid container spacing={3}>
//           {/* Tipo de Contenido */}
//           <Grid item xs={12} sm={6}>
//             <FormControl fullWidth variant="standard">
//               <InputLabel>Tipo de Contenido</InputLabel>
//               <Select name="type" value={block.type || ""} onChange={handleTypeChange} disabled={disabled}>
//                 <MenuItem value="text">Texto</MenuItem>
//                 <MenuItem value="text_image_right">Texto - Imagen Derecha</MenuItem>
//                 <MenuItem value="text_image_left">Texto - Imagen Izquierda</MenuItem>
//                 <MenuItem value="text_video_right">Texto - Video Derecha</MenuItem>
//                 <MenuItem value="text_video_left">Texto - Video Izquierda</MenuItem>
//                 <MenuItem value="image">Imagen</MenuItem>
//                 <MenuItem value="video">Video</MenuItem>
//                 <MenuItem value="quote">Cita</MenuItem>
//                 <MenuItem value="list">Listado de Puntos Claves</MenuItem>
//                 <MenuItem value="testimonial">Testimonios</MenuItem>
//                 <MenuItem value="image_text_block">Imágenes con Texto</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//           {/* Color de Fondo */}
//           <Grid item xs={12} sm={6}>
//             <FormControl fullWidth variant="standard">
//               <InputLabel>Color de Fondo</InputLabel>
//               <Select name="background" value={block.background || "sin_fondo"} onChange={handleSelectChange} disabled={disabled}>
//                 <MenuItem value="sin_fondo">Sin fondo</MenuItem>
//                 <MenuItem value="claro">Claro</MenuItem>
//                 <MenuItem className={isSpartan ? "visible" : "invisible"} value="red-spartan">Rojo (Spartan)</MenuItem>
//                 <MenuItem className={isSpartan ? "visible" : "invisible"} value="blue-spartan">Azul (Spartan)</MenuItem>
//                 <MenuItem className={isSpartan ? "visible" : "invisible"} value="green-spartan">Verde (Spartan)</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Renderizado condicional según tipo */}
//           {block.type.startsWith("text") && (
//             <>
//               <Grid item xs={12}>
//                 <TextField variant="standard" label="Título (opcional)" name="title" value={block.title||""} onChange={handleInputChange} disabled={disabled} fullWidth inputProps={{ maxLength: 80 }} />
//               </Grid>
//               <Grid item xs={12}>
//                 <Box position="relative">
//                   <TextField
//                     variant="standard"
//                     label="Contenido"
//                     name="content"
//                     value={block.content||""}
//                     onChange={handleInputChange}
//                     disabled={disabled}
//                     multiline rows={4} fullWidth
//                     inputProps={{ maxLength: 500 }}
//                     helperText={`${contentLength}/500 caracteres`}
//                   />
//                   <IconButton size="small" sx={{ position:"absolute",right:14,bottom:24 }} onClick={(e)=>handleEmojiButtonClick("content",e)} disabled={disabled}>
//                     <EmojiEmotions fontSize="small" />
//                   </IconButton>
//                 </Box>
//               </Grid>
//               {block.type.includes("image") && (
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle1" gutterBottom>Imagen</Typography>
//                   <DragDrop
//                     id={`contentBlock-image-${index}`}
//                     valueDefault={block.image||""}
//                     disabled={disabled}
//                     directoryNameList={["program","images"]}
//                     maxSizeMB={5}
//                     typeAllowed={["image/*"]}
//                     isOnlyOneFile isBlob specialCase showFileList={false}
//                     handleFiles={handleFiles}
//                   />
//                   <FormControlLabel
//                     control={<Checkbox checked={block.imageResizable||false} onChange={(e)=>onChange({...block,imageResizable:e.target.checked},index)} disabled={disabled}/>}
//                     label="Redimensionable"
//                   />
//                 </Grid>
//               )}
//             </>
//           )}

//           {block.type === "image" && (
//             <Grid item xs={12}>
//               <Typography variant="subtitle1" gutterBottom>Imagen</Typography>
//               <DragDrop
//                 id={`contentBlock-image-${index}`}
//                 valueDefault={block.image||""}
//                 disabled={disabled}
//                 directoryNameList={["program","images"]}
//                 maxSizeMB={10}
//                 typeAllowed={["image/*"]}
//                 isOnlyOneFile isBlob specialCase showFileList={false}
//                 handleFiles={handleFiles}
//               />
//             </Grid>
//           )}

//           {block.type === "video" && (
//             <Grid item xs={12}>
//               <TextField variant="standard" label="URL de Video (YouTube)" name="videoUrl" value={block.videoUrl||""} onChange={handleInputChange} disabled={disabled} fullWidth placeholder="https://www.youtube.com/watch?v=abc123" />
//             </Grid>
//           )}

//           {block.type === "quote" && (
//             <Grid item xs={12}>
//               <Box position="relative">
//                 <TextField variant="standard" label="Cita" name="quote" value={block.quote||""} onChange={handleInputChange} disabled={disabled} multiline rows={3} fullWidth />
//                 <IconButton size="small" sx={{position:"absolute",right:14,bottom:24}} onClick={(e)=>handleEmojiButtonClick("quote",e)} disabled={disabled}>
//                   <EmojiEmotions fontSize="small" />
//                 </IconButton>
//               </Box>
//             </Grid>
//           )}

//           {block.type === "list" && (
//             <>
//               <Grid item xs={12}>
//                 <TextField variant="standard" label="Título del Listado (opcional)" name="title" value={block.title||""} onChange={handleInputChange} disabled={disabled} fullWidth inputProps={{ maxLength: 80 }} />
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" gutterBottom>Imagen del Listado (opcional)</Typography>
//                 <DragDrop
//                   id={`contentBlock-listImage-${index}`}
//                   valueDefault={block.listImage||""}
//                   disabled={disabled}
//                   directoryNameList={["program","images"]}
//                   maxSizeMB={5}
//                   typeAllowed={["image/*"]}
//                   isOnlyOneFile isBlob specialCase showFileList={false}
//                   handleFiles={(files)=>handleFiles(files)}
//                 />
//                 <FormControlLabel
//                   control={<Checkbox checked={block.imageResizable||false} onChange={(e)=>onChange({...block,imageResizable:e.target.checked},index)} disabled={disabled}/>}
//                   label="Redimensionable"
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" gutterBottom>Puntos Claves</Typography>
//                 {block.listItems?.map((item,i)=>(
//                   <Box key={i} display="flex" alignItems="center" mb={1}>
//                     <TextField variant="standard" label={`Punto ${i+1}`} value={item} onChange={(e)=>handleListItemChange(e.target.value,i)} disabled={disabled} fullWidth />
//                     <IconButton onClick={(e)=>handleEmojiButtonClick("listItem",e,i)} disabled={disabled} color="primary"><EmojiEmotions/></IconButton>
//                     <IconButton onClick={()=>handleRemoveListItem(i)} disabled={disabled} color="error"><Cancel/></IconButton>
//                   </Box>
//                 ))}
//                 {block.listItems && block.listItems.length<10 && (
//                   <Button variant="contained" startIcon={<AddIcon/>} onClick={handleAddListItem} disabled={disabled}>Agregar Punto</Button>
//                 )}
//               </Grid>
//             </>
//           )}

//           {block.type === "testimonial" && (
//             <Grid item xs={12}>
//               <Typography variant="subtitle1" gutterBottom>Testimonios</Typography>
//               {block.testimonials?.map((t,ti)=>(
//                 <Box key={ti} mb={2} border="1px solid #ddd" borderRadius={2} p={2}>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12}><TextField variant="standard" label="Nombre" value={t.testimonialName} onChange={(e)=>handleTestimonialChange(e,ti,"testimonialName")} disabled={disabled} fullWidth inputProps={{maxLength:80}}/></Grid>
//                     <Grid item xs={12}><TextField variant="standard" label="Fuente (opcional)" value={t.testimonialSource||""} onChange={(e)=>handleTestimonialChange(e,ti,"testimonialSource")} disabled={disabled} fullWidth inputProps={{maxLength:40}}/></Grid>
//                     <Grid item xs={12}>
//                       <Box position="relative">
//                         <TextField variant="standard" label="Descripción" value={t.testimonialDescription} onChange={(e)=>handleTestimonialChange(e,ti,"testimonialDescription")} disabled={disabled} multiline rows={4} fullWidth helperText={`${t.testimonialDescription?.length||0}/225`} inputProps={{maxLength:225}}/>
//                         <IconButton size="small" sx={{position:"absolute",right:14,bottom:24}} onClick={(e)=>handleEmojiButtonClick("testimonialDescription",e,ti)} disabled={disabled}>
//                           <EmojiEmotions fontSize="small" />
//                         </IconButton>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Button variant="outlined" color="error" onClick={()=>handleRemoveTestimonial(ti)} disabled={disabled||block.testimonials!.length===1}>
//                         Eliminar Testimonio
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               ))}
//               {block.testimonials && block.testimonials.length<8 && (
//                 <Button variant="contained" startIcon={<AddIcon/>} onClick={handleAddTestimonial} disabled={disabled}>Agregar Testimonio</Button>
//               )}
//             </Grid>
//           )}

//           {block.type === "image_text_block" && (
//             <Grid item xs={12}>
//               <Typography variant="h6" gutterBottom>Bloque de Imágenes con Texto</Typography>
//               {block.imageTextItems?.map((item,i)=>(
//                 <Grid container spacing={2} key={i} alignItems="center" sx={{mb:2}}>
//                   <Grid item xs={12} sm={4}>
//                     <DragDrop
//                       id={`contentBlock-imageText-${index}-${i}`}
//                       valueDefault={item.image||""}
//                       disabled={disabled}
//                       directoryNameList={["program","images"]}
//                       maxSizeMB={5}
//                       typeAllowed={["image/*"]}
//                       isOnlyOneFile isBlob specialCase showFileList={false}
//                       handleFiles={(files)=>handleListImageFiles(files,block.imageTextItems!,i)}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={7}>
//                     <TextField variant="standard" label="Texto" value={item.text} onChange={(e)=>{
//                       const arr=[...(block.imageTextItems||[])];
//                       arr[i]={...arr[i],text:e.target.value};
//                       onChange({...block,imageTextItems:arr},index);
//                     }} disabled={disabled} fullWidth multiline rows={2} inputProps={{maxLength:225}} helperText={`${item.text.length}/225 caracteres`} />
//                   </Grid>
//                   <Grid item xs={12} sm={1}>
//                     <IconButton onClick={()=>{
//                       const arr=block.imageTextItems!.filter((_,j)=>j!==i);
//                       onChange({...block,imageTextItems:arr},index);
//                     }} disabled={disabled}>
//                       <Cancel/>
//                     </IconButton>
//                   </Grid>
//                 </Grid>
//               ))}
//               {(!block.imageTextItems||block.imageTextItems.length<6)&&(
//                 <Button variant="outlined" startIcon={<AddIcon/>} onClick={()=>{ 
//                   const arr=block.imageTextItems?[...block.imageTextItems,{text:""}]:[{text:""}];
//                   onChange({...block,imageTextItems:arr},index);
//                 }} disabled={disabled}>
//                   Agregar Elemento
//                 </Button>
//               )}
//             </Grid>
//           )}
//         </Grid>
//       </Box>

//       <Popover
//         open={Boolean(emojiPickerState?.anchorEl)}
//         anchorEl={emojiPickerState?.anchorEl}
//         onClose={handleEmojiClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         transformOrigin={{ vertical: "bottom", horizontal: "left" }}
//       >
//         <Box p={1}>
//           <Picker data={data} onEmojiSelect={handleEmojiSelect} />
//         </Box>
//       </Popover>
//     </Paper>
//   );
// };

// export default React.memo(ContentBlockForm);



"use client";

import React, { useState, useCallback } from "react";
import {
  Box,
  Grid,
  TextField,
  IconButton,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Paper,
  SelectChangeEvent,
  Button,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Cancel, Add as AddIcon, EmojiEmotions } from "@mui/icons-material";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import DragDrop from "../../../components/drag-drop/DragDrop";
import { Util } from "../../../../core/util/util";

// -----------------------------------------------------------------------------
// Interfaz ContentBlock
export interface ContentBlock {
  id?: string;
  type: string;
  title?: string;
  content?: string;
  listItems?: string[];
  listImage?: string;
  image?: string;
  videoUrl?: string;
  quote?: string;
  testimonials?: {
    testimonialName: string;
    testimonialDescription: string;
    testimonialSource?: string;
  }[];
  imageTextItems?: { image?: string; text: string }[];
  background?: string;
  imageResizable?: boolean;
}

// -----------------------------------------------------------------------------
// Estado EmojiPicker
interface EmojiPickerState {
  anchorEl: HTMLElement | null;
  field: string | null;
  listItemIndex?: number;
}

// -----------------------------------------------------------------------------
// Props del componente
interface ContentBlockFormProps {
  index: number;
  block: ContentBlock;
  onChange: (block: ContentBlock, index: number) => void;
  onRemove: (index: number) => void;
  onReorder: (oldIndex: number, newIndex: number) => void;
  maxPosition: number;
  disabled?: boolean;
  isSpartan?: boolean;
}

// -----------------------------------------------------------------------------
// Sub‑componente para image_text_block  (1 DragDrop  → handleImageTextFiles)
const ImageTextBlockForm: React.FC<{
  items: { image?: string; text: string }[];
  onChange: (items: { image?: string; text: string }[]) => void;
  disabled?: boolean;
}> = ({ items, onChange, disabled }) => {
  // DragDrop específico (usa handleImageTextFiles)
  // const handleImageTextFiles = (files: any[], itemIndex: number) => {
  //   const url =
  //     files.length > 0 && files[0].blob
  //       ? URL.createObjectURL(files[0].blob)
  //       : "";
  //   const newItems = [...items];
  //   newItems[itemIndex] = { ...newItems[itemIndex], image: url };
  //   onChange(newItems);
  // };

  const handleImageTextFiles = (files: any[], itemIndex: number) => {
    const url = files.length > 0 && files[0].blob ? URL.createObjectURL(files[0].blob) : "";
    const newItems = [...items];
    newItems[itemIndex] = { ...newItems[itemIndex], image: url };
    onChange(newItems);
  };

  const handleTextChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    itemIndex: number
  ) => {
    const newItems = [...items];
    newItems[itemIndex] = { ...newItems[itemIndex], text: e.target.value };
    onChange(newItems);
  };

  const addItem = () => {
    if (items.length < 6) onChange([...items, { text: "" }]);
  };

  const removeItem = (i: number) => {
    onChange(items.filter((_, idx) => idx !== i));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Bloque de Imágenes con Texto
      </Typography>

      {items.map((item, i) => (
        <Grid
          container
          spacing={2}
          key={i}
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Grid item xs={12} sm={4}>
            <DragDrop
              id={`imageText-${i}-${Date.now()}`}
              valueDefault={item.image || ""}
              disabled={disabled}
              directoryNameList={["program", "images"]}
              maxSizeMB={5}
              typeAllowed={["image/*"]}
              isOnlyOneFile
              isBlob
              specialCase
              showFileList={false}
              handleFiles={(files) => handleImageTextFiles(files, i)}
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <TextField
              variant="standard"
              label="Texto"
              value={item.text}
              onChange={(e) => handleTextChange(e, i)}
              disabled={disabled}
              fullWidth
              multiline
              rows={2}
              inputProps={{ maxLength: 225 }}
              helperText={`${item.text.length}/225 caracteres`}
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <IconButton
              onClick={() => removeItem(i)}
              disabled={disabled}
              aria-label="Eliminar elemento"
            >
              <Cancel />
            </IconButton>
          </Grid>
        </Grid>
      ))}

      {items.length < 6 && (
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={addItem}
          disabled={disabled}
        >
          Agregar Elemento
        </Button>
      )}
    </Box>
  );
};

// -----------------------------------------------------------------------------
// Componente principal
const ContentBlockForm: React.FC<ContentBlockFormProps> = ({
  index,
  block,
  onChange,
  onRemove,
  onReorder,
  maxPosition,
  disabled = false,
  isSpartan = false,
}) => {
  // ────────────────────── estado local
  const [openReorderModal, setOpenReorderModal] = useState(false);
  const [desiredPosition, setDesiredPosition] = useState(index + 1);
  const [emojiPickerState, setEmojiPickerState] =
    useState<EmojiPickerState | null>(null);

  // ────────────────────── cambios de tipo
  const handleTypeChange = useCallback(
    (e: SelectChangeEvent<string>) => {
      const t = e.target.value;
      let newBlock: Omit<ContentBlock, "id"> = { type: t, background: "sin_fondo" };

      if (t.startsWith("text"))
        newBlock = { type: t, title: "", content: "", background: "sin_fondo" };
      else if (t === "image")
        newBlock = { type: t, image: "", background: "sin_fondo" };
      else if (t === "video")
        newBlock = { type: t, videoUrl: "", background: "sin_fondo" };
      else if (t === "quote")
        newBlock = { type: t, quote: "", background: "sin_fondo" };
      else if (t === "list")
        newBlock = {
          type: t,
          listItems: [""],
          title: "",
          listImage: "",
          background: "sin_fondo",
        };
      else if (t === "testimonial")
        newBlock = {
          type: t,
          testimonials: [{ testimonialName: "", testimonialDescription: "" }],
          background: "sin_fondo",
        };
      else if (t === "image_text_block")
        newBlock = {
          type: t,
          imageTextItems: [{ text: "" }],
          background: "sin_fondo",
        };

      onChange({ ...newBlock, id: Util.getUniqueId(4) }, index);
    },
    [index, onChange]
  );

  // ────────────────────── handlers “genéricos”
  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      onChange({ ...block, [e.target.name]: e.target.value }, index),
    [block, index, onChange]
  );

  const handleSelectChange = useCallback(
    (e: SelectChangeEvent<string>) =>
      onChange({ ...block, [e.target.name]: e.target.value }, index),
    [block, index, onChange]
  );

  // ────────────────────── handleFiles → 3 DragDrop
  const handleFiles = useCallback(
    (files: any[]) => {
      if (files.length > 0 && files[0].blob) {
        const file = files[0];
        const url = URL.createObjectURL(file.blob);
        onChange({ ...block, image: url }, index);
      } else if (files.length === 0) {
        onChange({ ...block, image: "" }, index);
      }
    },
    [block, index, onChange]
  );

  // ────────────────────── handleListImageFiles → 1 DragDrop (inline mapping)
  const handleListImageFiles = useCallback(
    (
      files: any[],
      blockArray: { image?: string; text: string }[],
      itemIndex: number
    ) => {
      const newItems = blockArray ? [...blockArray] : [];

      if (files.length > 0 && files[0].blob) {
        const file = files[0];
        const url = URL.createObjectURL(file.blob);
        newItems[itemIndex] = { ...newItems[itemIndex], image: url };
      } else if (files.length === 0) {
        newItems[itemIndex] = { ...newItems[itemIndex], image: "" };
      }

      onChange({ ...block, imageTextItems: newItems }, index);
    },
    [block, index, onChange]
  );









  // ────────────────────── list handlers (texto)
  const handleListItemChange = useCallback(
    (val: string, i: number) => {
      if (!block.listItems) return;
      const newItems = [...block.listItems];
      newItems[i] = val;
      onChange({ ...block, listItems: newItems }, index);
    },
    [block, index, onChange]
  );

  const handleAddListItem = useCallback(() => {
    if (!block.listItems || block.listItems.length >= 10) return;
    onChange({ ...block, listItems: [...block.listItems, ""] }, index);
  }, [block, index, onChange]);

  const handleRemoveListItem = useCallback(
    (i: number) => {
      if (!block.listItems) return;
      onChange(
        { ...block, listItems: block.listItems.filter((_, idx) => idx !== i) },
        index
      );
    },
    [block, index, onChange]
  );

  // ────────────────────── testimonial handlers (texto)
  const handleTestimonialChange = useCallback(
    (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
      ti: number,
      field:
        | "testimonialName"
        | "testimonialDescription"
        | "testimonialSource"
    ) => {
      if (!block.testimonials) return;
      const newT = [...block.testimonials];
      newT[ti] = { ...newT[ti], [field]: e.target.value };
      onChange({ ...block, testimonials: newT }, index);
    },
    [block, index, onChange]
  );

  const handleAddTestimonial = useCallback(() => {
    if (!block.testimonials || block.testimonials.length >= 8) return;
    onChange(
      {
        ...block,
        testimonials: [
          ...block.testimonials,
          { testimonialName: "", testimonialDescription: "" },
        ],
      },
      index
    );
  }, [block, index, onChange]);

  const handleRemoveTestimonial = useCallback(
    (ti: number) => {
      if (!block.testimonials) return;
      onChange(
        {
          ...block,
          testimonials: block.testimonials.filter((_, idx) => idx !== ti),
        },
        index
      );
    },
    [block, index, onChange]
  );

  // ────────────────────── emoji picker
  const handleEmojiButtonClick = useCallback(
    (field: string, e: React.MouseEvent<HTMLElement>, listIdx?: number) => {
      if (disabled) return;
      setEmojiPickerState({ anchorEl: e.currentTarget, field, listItemIndex: listIdx });
    },
    [disabled]
  );

  const handleEmojiSelect = useCallback(
    (emoji: any) => {
      if (!emojiPickerState?.field) return;
      const ch = emoji.native;
      const { field, listItemIndex } = emojiPickerState;

      if (field === "listItem" && listItemIndex != null && block.listItems) {
        handleListItemChange(block.listItems[listItemIndex] + ch, listItemIndex);
      } else if (
        field === "testimonialDescription" &&
        listItemIndex != null &&
        block.testimonials
      ) {
        handleTestimonialChange(
          {
            target: {
              value:
                (block.testimonials[listItemIndex].testimonialDescription ||
                  "") + ch,
            },
          } as any,
          listItemIndex,
          "testimonialDescription"
        );
      } else {
        onChange(
          { ...block, [field]: ((block as any)[field] || "") + ch },
          index
        );
      }
      setEmojiPickerState(null);
    },
    [block, emojiPickerState, handleListItemChange, handleTestimonialChange, index, onChange]
  );

  const handleEmojiClose = useCallback(() => setEmojiPickerState(null), []);

  const contentLength = block.content?.length || 0;

  // ────────────────────── RENDER
  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        mb: 3,
        backgroundColor: disabled ? "grey.100" : "background.paper",
        position: "relative",
      }}
    >
      {/* CABECERA */}
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Bloque #{index + 1}</Typography>
        <Box>
          <Button
            variant="outlined"
            onClick={() => {
              setDesiredPosition(index + 1);
              setOpenReorderModal(true);
            }}
            disabled={disabled}
            sx={{ mr: 2 }}
          >
            MOVER
          </Button>
          <IconButton
            onClick={() => onRemove(index)}
            disabled={disabled}
            color="error"
          >
            <Cancel />
          </IconButton>
        </Box>
      </Grid>

      {/* MODAL DE REORDENAR */}
      <Dialog
        open={openReorderModal}
        onClose={() => setOpenReorderModal(false)}
      >
        <DialogTitle>Mover Bloque</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Elige posición entre 1 y {maxPosition}.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Posición"
            type="number"
            fullWidth
            variant="standard"
            value={desiredPosition}
            onChange={(e) => setDesiredPosition(Number(e.target.value))}
            onBlur={() => {
              let v = Number(desiredPosition);
              if (isNaN(v) || v < 1) v = 1;
              else if (v > maxPosition) v = maxPosition;
              setDesiredPosition(v);
            }}
            inputProps={{ min: 1, max: maxPosition }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenReorderModal(false)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={() => {
              onReorder(index, desiredPosition - 1);
              setOpenReorderModal(false);
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      {/* CONTENIDO */}
      <Box mt={2}>
        <Grid container spacing={3}>
          {/* Tipo */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="standard">
              <InputLabel>Tipo de Contenido</InputLabel>
              <Select
                name="type"
                value={block.type || ""}
                onChange={handleTypeChange}
                disabled={disabled}
              >
                <MenuItem value="text">Texto</MenuItem>
                <MenuItem value="text_image_right">
                  Texto ‑ Imagen Derecha
                </MenuItem>
                <MenuItem value="text_image_left">
                  Texto ‑ Imagen Izquierda
                </MenuItem>
                <MenuItem value="text_video_right">
                  Texto ‑ Video Derecha
                </MenuItem>
                <MenuItem value="text_video_left">
                  Texto ‑ Video Izquierda
                </MenuItem>
                <MenuItem value="image">Imagen</MenuItem>
                <MenuItem value="video">Video</MenuItem>
                <MenuItem value="quote">Cita</MenuItem>
                <MenuItem value="list">Listado de Puntos Claves</MenuItem>
                <MenuItem value="testimonial">Testimonios</MenuItem>
                <MenuItem value="image_text_block">
                  Imágenes con Texto
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Fondo */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="standard">
              <InputLabel>Color de Fondo</InputLabel>
              <Select
                name="background"
                value={block.background || "sin_fondo"}
                onChange={handleSelectChange}
                disabled={disabled}
              >
                <MenuItem value="sin_fondo">Sin fondo</MenuItem>
                <MenuItem value="claro">Claro</MenuItem>
                <MenuItem
                  className={isSpartan ? "visible" : "invisible"}
                  value="red-spartan"
                >
                  Rojo (Spartan)
                </MenuItem>
                <MenuItem
                  className={isSpartan ? "visible" : "invisible"}
                  value="blue-spartan"
                >
                  Azul (Spartan)
                </MenuItem>
                <MenuItem
                  className={isSpartan ? "visible" : "invisible"}
                  value="green-spartan"
                >
                  Verde (Spartan)
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* ────────────────────── Bloques condicionales */}
          {block.type.startsWith("text") && (
            <>
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  label="Título (opcional)"
                  name="title"
                  value={block.title || ""}
                  onChange={handleInputChange}
                  disabled={disabled}
                  fullWidth
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Box position="relative">
                  <TextField
                    variant="standard"
                    label="Contenido"
                    name="content"
                    value={block.content || ""}
                    onChange={handleInputChange}
                    disabled={disabled}
                    multiline
                    rows={4}
                    fullWidth
                    inputProps={{ maxLength: 500 }}
                    helperText={`${contentLength}/500 caracteres`}
                  />
                  <IconButton
                    size="small"
                    sx={{ position: "absolute", right: 14, bottom: 24 }}
                    onClick={(e) => handleEmojiButtonClick("content", e)}
                    disabled={disabled}
                  >
                    <EmojiEmotions fontSize="small" />
                  </IconButton>
                </Box>
              </Grid>

              {block.type.includes("image") && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Imagen
                  </Typography>

                  {/* 1º DragDrop → handleFiles */}
                  <DragDrop
                    id={`contentBlock-image-${index}`}
                    valueDefault={block.image || ""}
                    disabled={disabled}
                    directoryNameList={["program", "images"]}
                    maxSizeMB={5}
                    typeAllowed={["image/*"]}
                    isOnlyOneFile
                    isBlob
                    specialCase
                    showFileList={false}
                    handleFiles={handleFiles}
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={block.imageResizable || false}
                        onChange={(e) =>
                          onChange(
                            { ...block, imageResizable: e.target.checked },
                            index
                          )
                        }
                        disabled={disabled}
                      />
                    }
                    label="Redimensionable"
                  />
                </Grid>
              )}
            </>
          )}

          {block.type === "image" && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Imagen
              </Typography>

              {/* 2º DragDrop → handleFiles */}
              <DragDrop
                id={`contentBlock-image-${index}-solo`}
                valueDefault={block.image || ""}
                disabled={disabled}
                directoryNameList={["program", "images"]}
                maxSizeMB={10}
                typeAllowed={["image/*"]}
                isOnlyOneFile
                isBlob
                specialCase
                showFileList={false}
                handleFiles={handleFiles}
              />
            </Grid>
          )}

          {block.type === "video" && (
            <Grid item xs={12}>
              <TextField
                variant="standard"
                label="URL de Video (YouTube)"
                name="videoUrl"
                value={block.videoUrl || ""}
                onChange={handleInputChange}
                disabled={disabled}
                fullWidth
                placeholder="https://www.youtube.com/watch?v=abc123"
              />
            </Grid>
          )}

          {block.type === "quote" && (
            <Grid item xs={12}>
              <Box position="relative">
                <TextField
                  variant="standard"
                  label="Cita"
                  name="quote"
                  value={block.quote || ""}
                  onChange={handleInputChange}
                  disabled={disabled}
                  multiline
                  rows={3}
                  fullWidth
                />
                <IconButton
                  size="small"
                  sx={{ position: "absolute", right: 14, bottom: 24 }}
                  onClick={(e) => handleEmojiButtonClick("quote", e)}
                  disabled={disabled}
                >
                  <EmojiEmotions fontSize="small" />
                </IconButton>
              </Box>
            </Grid>
          )}

          {block.type === "list" && (
            <>
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  label="Título del Listado (opcional)"
                  name="title"
                  value={block.title || ""}
                  onChange={handleInputChange}
                  disabled={disabled}
                  fullWidth
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Imagen del Listado (opcional)
                </Typography>

                {/* 3º DragDrop → handleFiles  (block.image) */}
                <DragDrop
                  id={`contentBlock-listImage-${index}-${block.id}`}
                  valueDefault={block.image || ""}
                  disabled={disabled}
                  directoryNameList={["program", "images"]}
                  maxSizeMB={5}
                  typeAllowed={["image/*"]}
                  isOnlyOneFile
                  isBlob
                  specialCase
                  showFileList={false}
                  handleFiles={handleFiles}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={block.imageResizable || false}
                      onChange={(e) =>
                        onChange(
                          { ...block, imageResizable: e.target.checked },
                          index
                        )
                      }
                      disabled={disabled}
                    />
                  }
                  label="Redimensionable"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Puntos Claves
                </Typography>
                {block.listItems?.map((item, i) => (
                  <Box key={i} display="flex" alignItems="center" mb={1}>
                    <TextField
                      variant="standard"
                      label={`Punto ${i + 1}`}
                      value={item}
                      onChange={(e) =>
                        handleListItemChange(e.target.value, i)
                      }
                      disabled={disabled}
                      fullWidth
                    />
                    <IconButton
                      onClick={(e) => handleEmojiButtonClick("listItem", e, i)}
                      disabled={disabled}
                      color="primary"
                    >
                      <EmojiEmotions />
                    </IconButton>
                    <IconButton
                      onClick={() => handleRemoveListItem(i)}
                      disabled={disabled}
                      color="error"
                    >
                      <Cancel />
                    </IconButton>
                  </Box>
                ))}
                {block.listItems && block.listItems.length < 10 && (
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleAddListItem}
                    disabled={disabled}
                  >
                    Agregar Punto
                  </Button>
                )}
              </Grid>
            </>
          )}

          {block.type === "testimonial" && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Testimonios
              </Typography>
              {block.testimonials?.map((t, ti) => (
                <Box
                  key={ti}
                  mb={2}
                  border="1px solid #ddd"
                  borderRadius={2}
                  p={2}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="standard"
                        label="Nombre"
                        value={t.testimonialName}
                        onChange={(e) =>
                          handleTestimonialChange(e, ti, "testimonialName")
                        }
                        disabled={disabled}
                        fullWidth
                        inputProps={{ maxLength: 80 }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="standard"
                        label="Fuente (opcional)"
                        value={t.testimonialSource || ""}
                        onChange={(e) =>
                          handleTestimonialChange(e, ti, "testimonialSource")
                        }
                        disabled={disabled}
                        fullWidth
                        inputProps={{ maxLength: 40 }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Box position="relative">
                        <TextField
                          variant="standard"
                          label="Descripción"
                          value={t.testimonialDescription}
                          onChange={(e) =>
                            handleTestimonialChange(
                              e,
                              ti,
                              "testimonialDescription"
                            )
                          }
                          disabled={disabled}
                          multiline
                          rows={4}
                          fullWidth
                          helperText={`${t.testimonialDescription?.length || 0
                            }/225`}
                          inputProps={{ maxLength: 225 }}
                        />
                        <IconButton
                          size="small"
                          sx={{
                            position: "absolute",
                            right: 14,
                            bottom: 24,
                          }}
                          onClick={(e) =>
                            handleEmojiButtonClick(
                              "testimonialDescription",
                              e,
                              ti
                            )
                          }
                          disabled={disabled}
                        >
                          <EmojiEmotions fontSize="small" />
                        </IconButton>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => handleRemoveTestimonial(ti)}
                        disabled={
                          disabled || block.testimonials!.length === 1
                        }
                      >
                        Eliminar Testimonio
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ))}
              {block.testimonials && block.testimonials.length < 8 && (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleAddTestimonial}
                  disabled={disabled}
                >
                  Agregar Testimonio
                </Button>
              )}
            </Grid>
          )}

          {block.type === "image_text_block" && (
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Bloque de Imágenes con Texto
              </Typography>
              {block.imageTextItems?.map((item, i) => (
                <Grid container spacing={2} key={i} alignItems="center" sx={{ mb: 2 }}>
                  <Grid item xs={12} sm={4}>
                    <DragDrop
                      id={`contentBlock-imageText-${index}-${i}`}
                      valueDefault={item.image || ""}
                      disabled={disabled}
                      directoryNameList={["program", "images"]}
                      maxSizeMB={5}
                      typeAllowed={["image/*"]}
                      isOnlyOneFile
                      isBlob
                      specialCase
                      showFileList={false}
                      handleFiles={(files) => {

                        handleListImageFiles(files, block.imageTextItems, i);

                        // console.log("files", files);

                        // const blobUrl = files.length > 0 && files[0].blob ? URL.createObjectURL(files[0].blob) : "";
                        // const newItems = block.imageTextItems ? [...block.imageTextItems] : [];
                        // newItems[i] = { ...newItems[i], image: blobUrl };
                        // onChange({ ...block, imageTextItems: newItems }, index);

                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <TextField
                      variant="standard"
                      label="Texto"
                      value={item.text}
                      onChange={(e) => {
                        const newItems = block.imageTextItems ? [...block.imageTextItems] : [];
                        newItems[i] = { ...newItems[i], text: e.target.value };
                        onChange({ ...block, imageTextItems: newItems }, index);
                      }}
                      disabled={disabled}
                      fullWidth
                      multiline
                      rows={2}
                      inputProps={{ maxLength: 225 }}
                      helperText={`${item.text.length}/225 caracteres`}
                    />
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    <IconButton
                      onClick={() => {
                        const newItems = block.imageTextItems?.filter((_, j) => j !== i) || [];
                        onChange({ ...block, imageTextItems: newItems }, index);
                      }}
                      disabled={disabled}
                    >
                      <Cancel />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
              {(!block.imageTextItems || block.imageTextItems.length < 6) && (
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    const newItems = block.imageTextItems
                      ? [...block.imageTextItems, { text: "" }]
                      : [{ text: "" }];
                    onChange({ ...block, imageTextItems: newItems }, index);
                  }}
                  disabled={disabled}
                >
                  Agregar Elemento
                </Button>
              )}
            </Grid>
          )}


        </Grid>
      </Box>

      {/* POP‑OVER EMOJI */}
      <Popover
        open={Boolean(emojiPickerState?.anchorEl)}
        anchorEl={emojiPickerState?.anchorEl}
        onClose={handleEmojiClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={1}>
          <Picker data={data} onEmojiSelect={handleEmojiSelect} />
        </Box>
      </Popover>
    </Paper>
  );
};

export default React.memo(ContentBlockForm);







